import ProviderPromoCodeList from './components/ProviderPromoCodeList.js';
import connect from './connect';
import './assets/ProviderPromoCodeList.css';

export default connect(ProviderPromoCodeList);



// WEBPACK FOOTER //
// ./src/routes/ProviderPromoCodeList/index.js